{
  "GENERAL": {
    "CLOSE": "Sulje",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Etsi",
      "EMPTY_STATE": "Tuloksia ei löytynyt"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Vähintään {count} vaaditaan"
  }
}
